import { createStore, withProps } from '@ngneat/elf';
import { RefType, RefTypeDto } from '@/types';

export interface RefTypeStateProps {
  response?: RefType;
  dto?: Partial<RefTypeDto>;
}

export const refTypeFactory = (): RefType => ({
  id: 0,
  description: '',
});

export const refTypeInitialState: RefTypeStateProps = {
  response: structuredClone(refTypeFactory()),
  dto: structuredClone(refTypeFactory()),
};

export const refTypeStateStore = createStore({ name: 'refType-state' }, withProps<RefTypeStateProps>({ ...refTypeInitialState }));
